import { useMemo } from "react"
import { useReducedMotion as useFramerReducedMotion, type Variants } from "framer-motion"

export function useReducedMotion() {
  return useFramerReducedMotion() ?? false
}

export function useMotionSafeVariants(variants: Variants, fallback: Variants = {}) {
  const reduced = useReducedMotion()

  return useMemo(() => {
    return reduced ? fallback : variants
  }, [fallback, reduced, variants])
}
